import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgBiInfoCircleBigGreen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={37}
    height={38}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M18.5 3.166c-8.5 0-15.416 7.103-15.416 15.833S9.998 34.833 18.5 34.833c8.5 0 15.417-7.103 15.417-15.834C33.917 10.27 27 3.166 18.5 3.166Zm0 28.5c-6.8 0-12.333-5.683-12.333-12.667S11.7 6.333 18.5 6.333s12.334 5.682 12.334 12.666S25.3 31.666 18.5 31.666Z"
      fill="#00BC82"
    />
    <path
      d="M16.959 17.417h3.083v9.5h-3.084v-9.5Zm0-6.333h3.083v3.167h-3.084v-3.167Z"
      fill="#00BC82"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBiInfoCircleBigGreen);
export default ForwardRef;
